import { FilePdf } from '@phosphor-icons/react'
import { FC } from 'react'

import { IconPropsType } from '~/src/components/generic/PhosphorIcons/types'

const Icon: FC<IconPropsType> = ({ color, size, weight, mirrored }) => (
  <FilePdf color={color} size={size} weight={weight} mirrored={mirrored} />
)

export default Icon
